/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptVastMediaData } from '../models/V3StackAdaptVastMediaData';
import { HttpFile } from '../http/http';

/**
* Media configuration for VAST tags in StackAdapt campaign ads
*/
export class V3StackAdaptVastMedia {
    /**
    * List of API frameworks supported by the VAST url. Options are 'VPAID' and 'VAST'
    */
    'apiFrameworks'?: Array<string>;
    'media'?: V3StackAdaptVastMediaData;
    /**
    * URL for the VAST tag
    */
    'url'?: string;
    /**
    * Version of the VAST tag. Supports '2.0' and '3.0'
    */
    'version'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "apiFrameworks",
            "baseName": "apiFrameworks",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "media",
            "baseName": "media",
            "type": "V3StackAdaptVastMediaData",
            "format": ""
        },
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptVastMedia.attributeTypeMap;
    }

    public constructor() {
    }
}

